import { z } from "zod";
import { isoDate } from "./common";

export const ITEM_KINDS = ["card", "sealed"] as const;
export type ItemKind = (typeof ITEM_KINDS)[number];

/** Any item, as the fields every kind has. Its kind's own fields sit beside it. */
export const ItemSummary = z.object({
  id: z.string(),
  kind: z.enum(ITEM_KINDS),
  title: z.string(),
  subtitle: z.string().nullable(),
  brand: z.string().nullable(),
  category: z.string().nullable(),
  year: z.number().nullable(),
  imageUrl: z.string().nullable(),
  currentPriceCents: z.number().nullable(),
  floorPriceCents: z.number().nullable(),
  trackStock: z.boolean(),
  available: z.number(),
  confirmedAt: isoDate.nullable(),
});
export type ItemSummary = z.output<typeof ItemSummary>;

/** Sealed product as the pipeline reads it: a box, bundle, ETB, tin, pack or case. */
export const SealedInfo = z.object({
  category: z.string(),
  sport: z.string().nullable(),
  brand: z.string(),
  year: z.number().nullable(),
  set_name: z.string(),
  product_type: z.string(),
  /** The source's bracketed edition, e.g. `Logofractor`; empty for none. */
  product_variant: z.string(),
  configuration: z.string(),
  language: z.string(),
  product_full_name: z.string(),
  upc: z.string(),
});
export type SealedInfo = z.output<typeof SealedInfo>;
